import { categories } from "@/mocks/site";
import { SectionHead, goSection } from "./bits";

const bubble: Record<string, string> = {
  red: "bg-primary-100 text-primary-700",
  amber: "bg-accent-100 text-accent-800",
  stone: "bg-secondary-200 text-secondary-700",
};
const rule: Record<string, string> = {
  red: "bg-primary-500",
  amber: "bg-accent-500",
  stone: "bg-secondary-400",
};

export default function ColumnGuide({ onPickCategory }: { onPickCategory: (slug: string) => void }) {
  const pick = (slug: string) => {
    onPickCategory(slug);
    goSection("feed");
  };

  return (
    <section id="columns" className="scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Columns"
          title="六大栏目，把瓜吃到明白"
          desc="每个栏目对应一类最常被讨论的娱乐圈议题：从私德预警、法律落锤，到税务、合同与行业潜规则。点进栏目即可筛选阅读。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <button
              key={c.slug}
              type="button"
              onClick={() => pick(c.slug)}
              className="group relative overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 text-left transition hover:-translate-y-0.5 hover:border-primary-200"
            >
              <span className={`absolute inset-x-0 top-0 h-1 ${rule[c.tint]} opacity-0 transition group-hover:opacity-100`} />
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${bubble[c.tint]}`}
                >
                  <i className={c.icon} />
                </span>
                <span className="font-en text-xs uppercase tracking-[0.2em] text-foreground-300 transition group-hover:text-primary-400">
                  {c.en}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 min-h-[40px] text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition group-hover:opacity-100">
                进入栏目
                <i className="ri-arrow-right-line" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}